import { render, staticRenderFns } from "./Exames.vue?vue&type=template&id=5366d3e0"
import script from "./Exames.vue?vue&type=script&lang=js"
export * from "./Exames.vue?vue&type=script&lang=js"
import style0 from "./Exames.vue?vue&type=style&index=0&id=5366d3e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports